import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { PatientPrivateBillItem } from "./PatientPrivateBillItem";

class PatientPrivateBillListItem implements ITableDataSourceItem<PatientPrivateBillItem> {
    public Model: PatientPrivateBillItem;
    public Name: string;

    constructor(model: PatientPrivateBillItem) {
        this.Model = model;
    }
}

export { PatientPrivateBillListItem };
